import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "In this typical scene a teacher (red dot) is speaking in front of the students (plane area in green). For the optimisation we will evaluate the Clarity Index C50 under different modifications of the room.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/25/principle/principle-2.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
